export default {
  max: (size) =>
    `@media only screen and (max-width: ${Number.isInteger(size) ? `${size}px` : size})`,
  min: (size) =>
    `@media only screen and (min-width: ${Number.isInteger(size) ? `${size}px` : size})`,
};
